// extracted by mini-css-extract-plugin
var _1 = "kTRZZMyXrZcp29aqE_gw";
var _2 = "hZ3Zgwymd1XE6Yv58CfC";
export { _1 as "root", _2 as "row" }
